import { render, staticRenderFns } from "./privStaffTenTe.vue?vue&type=template&id=5a424947&scoped=true&"
import script from "./privStaffTenTe.vue?vue&type=script&lang=js&"
export * from "./privStaffTenTe.vue?vue&type=script&lang=js&"
import style0 from "./privStaffTenTe.vue?vue&type=style&index=0&id=5a424947&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a424947",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
